<template>
    <span :style="{ color: iconColor }" class="display-flex align-items-center" style="gap: 4px">
        <font-awesome-icon :icon="iconName" style="font-size: 1.2em" />
    </span>
</template>

<script setup>
import { computed } from 'vue'
import { dataRed, dataOrange, dataYellow } from '@/styles/js_variables.module.scss'

const props = defineProps({
    params: {
        type: Object,
        required: true,
    },
})

const score = computed(() => parseFloat(props.params.value))
const iconName = computed(() => {
    if (score.value >= 4) return ['fas', 'wifi']
    if (score.value >= 2) return ['fas', 'wifi-fair']
    return ['fas', 'wifi-weak']
})

const iconColor = computed(() => {
    if (score.value >= 4) return dataRed
    if (score.value >= 2) return dataOrange
    return dataYellow
})

const value = computed(() => props.params.value)
</script>
